import { StyleSheet } from 'aphrodite';
import { aceGray, borderColor, darkGrayFontColor, destructive } from '../../../../../../../web/styles/colors';
import { CssSelectors } from '../../../../../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	surveyForm: {
		display: 'flex',
		flexDirection: 'column',
		width: '100%',
	},
	formContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: 24,
		margin: '16px auto',
		width: '100%',
		maxWidth: 600,
	},
	formControl: {
		display: 'flex',
		flexDirection: 'column',
		gap: 8,
		width: '100%',
		alignItems: 'flex-start',
		justifyContent: 'flex-start',
		...CssSelectors.allDescendants(
			{
				width: '100%',
			},
			'.text-input'
		),
	},
	formControlFullWidth: {
		display: 'flex',
		flexDirection: 'column',
		gap: 8,
		width: '100%',
		alignItems: 'flex-start',
		justifyContent: 'flex-start',
		...CssSelectors.allDescendants(
			{
				width: '100%',
			},
			'.text-input'
		),
	},
	label: {
		fontSize: 14,
		fontWeight: 600,
		color: darkGrayFontColor,
		textAlign: 'left',
	},
	textInput: {
		width: '100%',
		padding: 10,
		border: `1px solid ${aceGray}`,
		borderRadius: 4,
	},
	checkbox: {
		marginBottom: 8,
		textAlign: 'left',
	},
	selectBoxTriggerButton: {
		width: '100%',
		padding: 10,
		textAlign: 'left',
		borderRadius: 4,
		border: `1px solid ${aceGray}`,
		minWidth: 300,
	},
	errorMessage: {
		color: destructive,
		fontSize: 12,
		marginTop: 4,
		textAlign: 'left',
	},
	name: {
		fontSize: 24,
		margin: 0,
	},
	noMargin: {
		margin: 0,
	},
	divider: {
		height: 1,
		background: borderColor,
		margin: '24px 0',
		width: '100%',
	},
	actions: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		width: '100%',
	},
	buttonContainer: {
		display: 'flex',
		justifyContent: 'center',
		width: '100%',
	},
	introContent: {
		fontSize: 14,
		maxWidth: 600,
		margin: '12px auto',
		textAlign: 'left',
	},
	loadingLogo: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: '100%',
	},
	countrySelector: {
		width: '100%',
		...CssSelectors.allDescendants(
			{
				width: '100%',
			},
			'.select-box'
		),
	},
	addressSection: {
		display: 'flex',
		flexDirection: 'column',
		gap: 16,
		textAlign: 'left',
	},
	addressHeader: {
		fontWeight: 600,
		fontSize: 16,
		marginBottom: 16,
		color: darkGrayFontColor,
		margin: 0,
	},
	addressFieldRow: {
		display: 'flex',
		gap: 16,
		width: '100%',
		'@media (max-width: 768px)': {
			flexDirection: 'column',
			gap: 12,
		},
	},
	countrySelectorContainer: {
		width: '100%',
		...CssSelectors.allChildren(
			{
				width: '100%',
			},
			'div'
		),
	},
});
